import React from 'react';
import DealEtikett from './DealEtikett/DealEtikett';
import Overlay from './Overlay/Overlay';
import Picture from '../../../UI/Picture/Picture';
import mediaUrl from '../../../../shared/helpers/mediaUrl';
import filmDetailUrl from '../../../../shared/helpers/filmDetailUrl';

const Poster = ({ film }) => {
  const { id, title, deal } = film;
  const detailUrl = filmDetailUrl(film);

  return (
    <div className="movie-poster" style={{ display: 'inline-block' }}>
      <div className="movie-poster-preview">
        <a href={detailUrl}>
          <Picture
            imageSet={[
              {
                source: mediaUrl(`/_imageserver/400f${id}.jpg`),
                mediaQuery: '(max-width: 400px)',
              },
              {
                source: mediaUrl(`/_imageserver/480f${id}.jpg`),
                mediaQuery: '(min-width: 401px) and (max-width: 479px)',
              },
            ]}
            fallbackImage={mediaUrl(`/_imageserver/400f${id}.jpg`)}
            title={title}
          />
        </a>
        {deal && <DealEtikett deal={deal} />}
      </div>
      <Overlay film={film} />
    </div>
  );
};

export default Poster;
